import { useTracking } from 'react-tracking';
import { ANALYTICS_TYPE_PROP, SPOTIM_ANALYTICS, toAnalytics } from './sendEventUtils';

export const useSendEvent = () => {
  const { trackEvent } = useTracking();

  const sendEvent = (data: any) => {
    trackEvent({
      ...toAnalytics({ ...data }),
      [ANALYTICS_TYPE_PROP]: SPOTIM_ANALYTICS
    });
  };

  return { sendEvent };
};
